<div
  class="remote-support-home w-full h-full flex flex-col justify-center items-center gap-4"
  [class.dark-theme-portal-base]="isDarkMode$ | async"
>
  <div class="remote-support-home__icon p-5 flex justify-center items-center rounded-full">
    <mat-icon class="s-76 material-symbols-rounded fill">headphones</mat-icon>
  </div>

  <div class="remote-support-home__title">Welcome, Support agent!</div>
  <div class="remote-support-home__message">You're in Remote Support mode. Let’s help the customer succeed!</div>
</div>
